import React from "react";
import {useTranslation} from "react-i18next";
import CreditBadge from "pages/Front/Booking/Credits/components/CreditBadge";
import OnlineTicket from "components/Icons/OnlineTicket";

const PackageTicketsBadge = () => {
    const {t} = useTranslation();
    return (
        <div className={"flex flex-col"}>
            <div className={"flex flex-row items-center justify-center space-x-2"}>
                <OnlineTicket />
                <span className={"font-bold text-2xl text-black"}>{t("Tickets")}</span>
                <CreditBadge title={t("Required")} color={"bg-brand-yellow"} />
            </div>
        </div>
    );
};

export default PackageTicketsBadge;
